var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { connect } from 'react-redux';
import { assign, map, get, set } from 'lodash';
import { DetailView } from '../detail-view';
/**
 * 为subForm中的属性设置值
 * @param entityId            实体id
 * @param properties          实体属性
 * @param fieldValues         实体对应的值
 * @param fieldsFromProps     组件配置的表单域
 */

function generateFields(entityId, properties, fieldValues, fieldsFromProps) {
  if (fieldValues === void 0) {
    fieldValues = {};
  }

  var fields = {};
  map(fieldsFromProps, function (field) {
    var fieldProperty = field.property,
        config = __rest(field, ["property"]); // 从实体中获取属性配置，实体中的 path 为 style.properties.color，配置中 path 为 style.color


    var entityPropertyPath = get(properties, fieldProperty.replace(/\./g, '.properties.'));

    if (!entityPropertyPath) {
      throw new Error("Property " + fieldProperty + " not found in Entity " + entityId);
    }

    if (fieldProperty.split('.').length > 1) {
      var parentProperty = properties;
      var parentField = '';

      for (var _i = 0, _a = fieldProperty.split('.'); _i < _a.length; _i++) {
        var configProperty = _a[_i];
        var entityProperty = parentProperty[configProperty];

        if (entityProperty.type === 'object.subForm') {
          if (!fields[configProperty]) {
            fields[configProperty] = assign({}, entityProperty);
            fields[configProperty].value = fieldValues[configProperty];
          }
        } else {
          var propertyPath = parentField + ("." + configProperty);
          var valuePath = propertyPath + ".value";
          set(fields, propertyPath, assign({}, entityProperty, config));
          set(fields, valuePath, get(fieldValues, fieldProperty));
        }

        parentProperty = entityProperty.properties;
        parentField = configProperty + ".fields";
      }
    } else {
      fields[fieldProperty] = assign({}, properties[fieldProperty], config);
      fields[fieldProperty].value = fieldValues[fieldProperty];
    }
  });
  return fields;
}

function mapStateToProps(_state, props) {
  var componentId = props.id,
      entity = props.entity,
      fieldsFromProps = props.fields;
  var entityId = entity.id,
      properties = entity.metainfo.properties; // 未配置表单域

  if (!fieldsFromProps) {
    throw new Error("Fields not found in Component " + componentId);
  }

  var fieldValues = entity.fields || {};
  var fields = generateFields(entityId, properties, fieldValues, fieldsFromProps);
  return {
    state: {
      fields: fields,
      fieldValues: fieldValues
    }
  };
}

export var Detail = connect(mapStateToProps)(DetailView);